module.exports = __webpack_public_path__ + "img/007-jester.bf59681e.png";